import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { Column, Typography } from "@aviary";
import { useInitialProps } from "@unauthenticated/catalog/context";
import { l } from "@unauthenticated/catalog/locales/i18n";

import * as styles from "../Footer.styles";

const CopyrightStatement: FC = () => {
  const { t } = useTranslation();
  const { fullscriptCountry } = useInitialProps();

  return (
    <Column columnWidth={6} textAlign="left">
      <Typography type="h5">{t(l.footer.CopyrightAllRightsReserved)}</Typography>
      {fullscriptCountry === "US" && (
        <div css={styles.footerText}>
          <Typography type="caption">{t(l.footer.FDAStatements)}</Typography>
        </div>
      )}
    </Column>
  );
};

export { CopyrightStatement };
